import { useSessionWindow, useSessionWindows } from './query/useQuerySessionWindows';

// This function retrieves the active tab data for a specific session and window index.
// It uses the `useSessionWindows` and `useSessionWindow` hooks to get the session windows and the active tab data.
// The `sessionId` and `windowIndex` are passed as parameters to identify the specific session and window.
// The function returns:
// - `tabName`: The name of the active tab.
// - `documentId`: The document ID of the active tab.
//
export function useActiveTabData(sessionId: string) {
  const { activeWindowIndex } = useSessionWindows({ sessionId });
  const windowData = useSessionWindow({ sessionId, windowIndex: activeWindowIndex });
  return {
    tabName: windowData?.activeTab?.name ?? null,
    documentId: windowData?.activeTab?.documentId ?? '',
  };
}
